module.exports = __webpack_public_path__ + "img/meddow1.6dc32c47.jpg";